import request from '@/utils/request'

// 获取租赁管理列表
export function GetLeaseList(data) {
  return request({
    url: '/car/lease/data',
    method: 'post',
    data
  })
}
// 获取排序方式列表
export function GetSortList() {
  return request({
    url: '/car/carInform/sortList',
    method: 'post'
  })
}
// 获取车辆详情
export function GetCarDetail(data) {
  return request({
    url: '/car/carInform/getDetail',
    method: 'post',
    data
  })
}
// 获取车辆历史报警列表
export function GetCarAlarmList(data) {
  return request({
    url: '/car/carInform/getCarAlarm',
    method: 'post',
    data
  })
}
// 获取车辆租赁信息列表
export function GetCarLeaseList(data) {
  return request({
    url: '/car/carInform/getCarLease',
    method: 'post',
    data
  })
}

// 新增
export function addCarInform(data) {
  return request({
    url: '/car/carInform/add',
    method: 'post',
    data
  })
}

// 编辑
export function editCarInform(data) {
  return request({
    url: '/car/carInform/setDetail',
    method: 'post',
    data
  })
}

// 车门
export function getCarDoor(data) {
  return request({
    url: '/car/carInform/getCarDoor',
    method: 'post',
    data
  })
}
// 忽略
export function getconfirm(data) {
  return request({
    url: '/car/alarm/confirm',
    method: 'post',
    data
  })
}

// 新增房车租赁信息
export function addRentInfo(data) {
  return request({
    url: '/car/lease/addRentInfo',
    method: 'post',
    data
  })
}

// 查询房车租赁详细信息
export function getLeaseDetail(data) {
  return request({
    url: '/car/lease/getLeaseDetail',
    method: 'post',
    data
  })
}

//房车租赁收回时更新操作
export function updateRentInfo(data) {
  return request({
    url: '/car/lease/updateRentInfo',
    method: 'post',
    data
  })
}

// 查询未出租的车辆列表细信息
export function geteSelectCarInfo(data) {
  return request({
    url: '/car/lease/geteSelectCarInfo',
    method: 'post',
    data
  })
}

// 删除房车租赁信息
export function deleteRentInfo(data) {
  return request({
    url: '/car/lease/delete',
    method: 'post',
    data
  })
}